import { useState } from "react";
import { Box, Button, Container, TextField, Typography } from "@mui/material";
import axios from "axios";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/forgot-password`, { email });
      console.log(res.data.message);
      
      setMessage(res.data.message || "Password reset link sent to your email.");
    } catch (err) {
      console.error(err.response.data);
      setError(err.response?.data?.message || "Something went wrong.");
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 20, mb: 30 }}>
      <Box component="form" onSubmit={handleSubmit} display="flex" flexDirection="column" gap={2}>
        <Typography variant="h5" align="center">Forgot Password?</Typography>
        <TextField
          label="Email"
          type="email"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        {message && <Typography color="primary">{message}</Typography>}
        {error && <Typography color="error">{error}</Typography>}
        <Button type="submit" variant="contained" fullWidth>Send Reset Link</Button>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
